<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    no-close-on-esc
    no-close-on-backdrop
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-user-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Thông tin</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <!-- BODY -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="Đơn vị"
            rules="required"
          >
            <b-form-group :state="getValidationState(validationContext)">
              <label>Đơn vị<span style="color: red">*</span></label>
              <treeselect
                v-on:select="formatDonVis"
                :options="treeOptions"
                value-format="object"
                v-model="value"
                :searchable="true"
                :show-count="true"
                :default-expand-level="1"
                :normalizer="normalizer"
                placeholder="Chọn đơn vị"
                @input="getCBCC"
              />
              <b-form-invalid-feedback
                :state="getValidationState(validationContext)"
              >
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider #default="validationContext" name="Cán bộ">
            <label label-for="canBo">Cán bộ</label>
            <b-form-group>
              <v-select
                placeholder=""
                v-model="canBo"
                label="hoVaTen"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="listCanBo"
                :reduce="(val) => val"
                :clearable="false"
                input-id="canBo"
                @input="canbo"
              >
                <template #option="{ hoVaTen, email }">
                  <div class="d-flex justify-content-between">
                    <span>{{ hoVaTen }}</span>
                    <span>{{ email }}</span>
                  </div>
                </template>
              </v-select>
              <b-form-invalid-feedback
                :state="getValidationState(validationContext)"
              >
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Full Name -->
          <validation-provider
            #default="validationContext"
            name="Họ và tên"
            rules="required"
          >
            <label label-for="full-name"
              >Họ và tên <span style="color: red">*</span></label
            >
            <b-form-group>
              <b-form-input
                id="full-name"
                v-model="fullName"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Username -->
          <validation-provider
            #default="validationContext"
            name="Username"
            rules="required"
          >
            <label label-for="username"
              >Tài khoản (UserName)<span style="color: red">*</span></label
            >
            <b-form-group>
              <b-form-input
                id="username"
                v-model="userName"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Password -->
          <!-- <validation-provider
            #default="validationContext"
            name="Password"
            rules="alpha-num"
          >
            <b-form-group label="Password" label-for="password">
              <b-form-input
                id="password"
                v-model="userData.password"
                type="password"
                :disabled="isWait"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider> -->

          <validation-provider
            #default="validationContext"
            name="Vai trò"
            rules=""
          >
            <b-form-group
              label="Vai trò"
              label-for="vaiTro"
              :state="getValidationState(validationContext)"
            >
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                v-model="unitRoleView"
                :reduce="(val) => val"
                :options="listRole"
                label="name"
                :disabled="isWait"
                :clearable="false"
                input-id="vaiTro"
              />
              <b-form-invalid-feedback
                :state="getValidationState(validationContext)"
              >
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              :disabled="isWait"
              type="submit"
            >
              Lưu
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              :disabled="isWait"
              @click="hide"
            >
              Đóng
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
/* eslint-disable */
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import { required, alphaNum, email } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  UserCreate,
  UserUpdate,
  UserUpdateUnitRole,
} from "@/services/api/DefaultTemplate/UserService";
import { GetByCurrentUser } from "@/services/api/DefaultTemplate/RoleService";
import { CanBoCongChucGetByIddv } from "@/services/api/HoSoCanBoCongChuc/CanBoCongChucService";
import vi from "vee-validate/dist/locale/vi.json";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
localize("vi", vi);

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    Treeselect,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
    treeOptions: {
      type: Array,
      required: true,
    },
    listRole: {
      type: Array,
    },
  },
  watch: {
    isAddNewUserSidebarActive(val) {
      if (val) {
        this.value = null;
        this.canBo = null;
        this.listCanBo = [];
        this.fullName = null;
        this.userName = null;
        this.unitRoleView = null;
      }
    },
  },
  data() {
    return {
      isWait: false,
      required,
      alphaNum,
      email,
      role: null,
      value: null,
      canBo: null,
      listCanBo: [],
      userName: null,
      fullName: null,
      unitRoleView: null,
    };
  },
  created() {
    // this.getRoles();
  },
  methods: {
    formatDonVis(node, instanceId) {
      this.value = {
        id: node.id,
        ten: node.label,
        maCoQuan: node.maCoQuan,
        isSyncQG: node.isSyncQG,
      };
    },
    normalizer(node) {
      if (node.children == null || node.children == "null") {
        delete node.children;
      }
    },
    getCBCC(value) {
      // console.log("value", value);

      if (value) {
        CanBoCongChucGetByIddv(value.id).then((res) => {
          this.listCanBo = res.data;
        });
      } else this.listCanBo = [];
    },
    canbo() {
       console.log("canbo", this.canBo);
      if (this.canBo) {
        this.fullName = this.canBo.hoVaTen;
        this.userName = this.canBo.email;

      }
    },
    // getRoles() {
    //   GetByCurrentUser().then((res) => {
    //     // console.log("res", res);
    //     this.listRole = res.data;
    //   });
    // },
    async onSubmit() {
      console.log("LOG SUBMIT ");
      if (this.isWait) {
        console.log("LOG SUBMIT IF  ");
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Notification",
            icon: "CoffeeIcon",
            variant: "info",
            text: "In Progress",
          },
        });
      } else {
        console.log("LOG SUBMIT ELSE " , this.canBo);
        // console.log("this.userData", this.userData);
        // if (this.userData.id && this.userData.id != "") {
        //   //Update
        //   this.isWait = true;
        //   var res = await UserUpdateUnitRole(this.userData);
        //   this.isWait = false;
        //   if (res.isError) {
        //     this.$toast({
        //       component: ToastificationContent,
        //       position: "top-right",
        //       props: {
        //         title: "Thất bại",
        //         icon: "AlertTriangleIcon",
        //         variant: "error",
        //         text: res.message,
        //       },
        //     });
        //   } else {
        //     this.$toast({
        //       component: ToastificationContent,
        //       position: "top-right",
        //       props: {
        //         title: "Thành công",
        //         icon: "CheckIcon",
        //         variant: "success",
        //         text: res.message,
        //       },
        //     });
        //     this.$emit("update:is-add-new-user-sidebar-active", false);
        //     this.$emit("refetch-data");
        //   }
        // } else {
        //Create
        this.isWait = true;
        console.log("NGUYEN TUAN KIET CAN BO : ", this.canBo)
        var res = await UserCreate({
          userName: this.userName,
          email: this.canBo != null ? this.canBo.email : null,
          idCBCC : this.canBo != null ? this.canBo.id : null,
          fullName: this.fullName,
          donVi: this.value,
          unitRoleView: this.unitRoleView,
        });
        this.isWait = false;
        if (res.isError) {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Thất bại",
              icon: "AlertTriangleIcon",
              variant: "error",
              text: res.message,
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Thành công",
              icon: "CheckIcon",
              variant: "success",
              text: res.message,
            },
          });
          this.$emit("update:is-add-new-user-sidebar-active", false);
          this.$emit("refetch-data");
        }
        // }
      }
    },
  },
  setup(props, { emit }) {
    const { refFormObserver, getValidationState, resetForm } = formValidation(
      () => {
        //Reset form
      }
    );

    return {
      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

#add-new-user-sidebar {
  width: 50%;
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
